import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Trash2Outline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, DeprecatedIconButton, Tooltip } from '@lyearn/ui';
import { buttonSizeStyles } from '@/utils/styles';

import { SkillRemoveButtonProps } from './types';

function SkillRemoveButton(props: SkillRemoveButtonProps) {
  const { onRemove, isMindset } = props;
  const { t } = useTranslation(['Skills']);
  const SkillParam = isMindset ? 'Mindset' : 'Skill';

  return (
    <DeprecatedIconButton
      appearance="secondary"
      className={cn(buttonSizeStyles(1.6, 2.4), 'me-8')}
      size="x-small"
      variant="ghost"
      onClick={onRemove}>
      <Tooltip placement="right" title={t(`Skills:${SkillParam}.RemoveSkill`)}>
        <Box>
          <Trash2Outline />
        </Box>
      </Tooltip>
    </DeprecatedIconButton>
  );
}

export default React.memo(SkillRemoveButton);
